export default __webpack_public_path__ + "static/media/Right.58270108.png";